import gsap from 'gsap';
import * as $ from 'jquery';

export function projectjavascript() {

  $(document).ready(function() {

  // if(this.slider){
  //   this.slider.remove()
  //   this.sliderItems.remove()
  //   this.prev.remove()
  //   this.next.remove()
  //   this.sliderinfo.remove()
  //   this.projecttl.pause(0)
  // }
  // if(this.projecttl){
  //   this.projecttl.pause(0)
  //   this.projecttl.play()

  // }
  // if(this.projecttl == gsap.timeline()){
  //   this.projecttl.pause(0)
  // }
  console.log("call project load")
  if(this.projecttl){
    console.log(this.projecttl)
    this.projecttl.pause()
    this.projecttl.play()
  }
  else{
    this.projecttl = gsap.timeline()
  }
  this.slider = document.getElementById('slider')
  this.sliderItems = document.getElementById('items')
  this.prev = document.getElementById('prev')
  this.next = document.getElementById('next');
  this.sliderinfo = document.querySelector('.sliderinfo')
  this.projecttl.to(this.slider,{duration:0.7,clipPath:"inset(0 0 0% 0)",delay:0.5})
  this.projecttl.to(this.slider,{clipPath:"none"})
  this.projecttl.to([this.next,this.prev],{duration:0.2,scale: 1},"-=0.5")
  this.projecttl.to(this.sliderinfo,{duration: 0.5,y:0, opacity:1})
  console.log()
  this.call = slide(this.slider, this.sliderItems, this.prev, this.next);
return "success"
  })
}

function slide(wrapper, items, prev, next) {
  var posX1 = 0,
      posX2 = 0,
      posInitial,
      posFinal,
      threshold = 100,
      slides = items.getElementsByClassName('slide'),
      slidesLength = slides.length,
      slideSize = items.getElementsByClassName('slide')[0].offsetWidth,
      firstSlide = slides[0],
      lastSlide = slides[slidesLength - 1],
      cloneFirst = firstSlide.cloneNode(true),
      cloneLast = lastSlide.cloneNode(true),
      index = 0,
      allowShift = true;
  
  // Clone first and last slide
  items.appendChild(cloneFirst);
  items.insertBefore(cloneLast, firstSlide);
  wrapper.classList.add('loaded');
  
  // Mouse and Touch events
  items.onmousedown = dragStart;
  
  // Touch events
  items.addEventListener('touchstart', dragStart);
  items.addEventListener('touchend', dragEnd);
  items.addEventListener('touchmove', dragAction);
  
  // Click events
  prev.addEventListener('click', function () { shiftSlide(-1) });
  next.addEventListener('click', function () { shiftSlide(1) });
  
  // Transition events
  items.addEventListener('transitionend', checkIndex);
  
  function dragStart (e) {
    e = e || window.event;
    e.preventDefault();
    posInitial = items.offsetLeft;
    
    if (e.type == 'touchstart') {
      posX1 = e.touches[0].clientX;
    } else {
      posX1 = e.clientX;
      document.onmouseup = dragEnd;
      document.onmousemove = dragAction;
    }
  }
  
  function dragAction (e) {
    e = e || window.event;
    
    if (e.type == 'touchmove') {
      posX2 = posX1 - e.touches[0].clientX;
      posX1 = e.touches[0].clientX;
    } else {
      posX2 = posX1 - e.clientX;
      posX1 = e.clientX;
    }
    items.style.left = (items.offsetLeft - posX2) + "px";
  }
  
  function dragEnd (e) {
    posFinal = items.offsetLeft;
    if (posFinal - posInitial < -threshold) {
      shiftSlide(1, 'drag');
    } else if (posFinal - posInitial > threshold) {
      shiftSlide(-1, 'drag');
    } else {
      items.style.left = (posInitial) + "px";
    }
  
    document.onmouseup = null;
    document.onmousemove = null;
  }
  
  function shiftSlide(dir, action) {
    items.classList.add('shifting');
    
    if (allowShift) {
      if (!action) { posInitial = items.offsetLeft; }
  
      if (dir == 1) {
        items.style.left = (posInitial - slideSize) + "px";
        index++;      
      } else if (dir == -1) {
        items.style.left = (posInitial + slideSize) + "px";
        index--;      
      }
    };
    
    allowShift = false;
  }
    
  function checkIndex (){
    items.classList.remove('shifting');
  
    if (index == -1) {
      items.style.left = -(slidesLength * slideSize) + "px";
      index = slidesLength - 1;
    }
  
    if (index == slidesLength) {
      items.style.left = -(1 * slideSize) + "px";
      index = 0;
    }
    
    allowShift = true;
  }
  }